import { Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SearchByUsersController } from "./controller";
import "./index.css";
import { KeyConditionActions } from "../../../model";
import { isEmptyString, isNullOrUndefined } from "src/common/utils";

export const NoUsersFoundMessage = "No users";
export const SearchByUsersPlaceholder = "Search by name or employee id";
export const InitialDropdownMessage = "Please enter some characters for suggestions";
export const DropdownMessageFullName = "Please enter at least 3 characters in the name";
export const DropdownMessageEmpId = "Please enter 5 digit employee id";

function SearchByUsers({ setCurrentStepState, setDisplayLabels }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(KeyConditionActions.resetModifiedKeyCondition());
    dispatch(KeyConditionActions.resetSpecialConditionChecked());
  }, []);

  const [placeholderText, setPlaceholderText] = useState(SearchByUsersPlaceholder);
  const {
    searchUsersWithName,
    renderDropdownWithPagination,
    userInput,
    options,
    progress,
    onUserSelect,
    selectedUser,
    searchValue,
  } = SearchByUsersController(setCurrentStepState, setDisplayLabels);

  function setInputValue() {
    if (isNullOrUndefined(userInput) || isEmptyString(userInput.value)) {
      setPlaceholderText(SearchByUsersPlaceholder);
    } else {
      setPlaceholderText("");
    }
  }

  function notFoundContent() {
    if (progress !== null) return <Spin size="small" />;

    if (isNullOrUndefined(userInput) || isEmptyString(userInput.value))
      return InitialDropdownMessage;

    if (userInput.value.length >= userInput.minChars) return NoUsersFoundMessage;

    if (userInput.isNumber) return DropdownMessageEmpId;
    else return DropdownMessageFullName;
  }

  function onSearch(value) {
    const isNumber = /^\d+$/.test(value);
    if (isNumber)
      searchUsersWithName({
        isNumber: true,
        minChars: 5,
        value: value,
      });
    else
      searchUsersWithName({
        isNumber: false,
        minChars: 3,
        value: value,
      });
  }

  const isError =
    userInput && userInput.value.length > 0 ? userInput.value.length < userInput.minChars : false;

  return (
    <div className="key-condition-search-by-member">
      <Select
        showSearch={isNullOrUndefined(selectedUser)}
        placeholder={placeholderText}
        value={searchValue}
        searchValue={userInput?.value ?? undefined}
        options={options}
        notFoundContent={notFoundContent()}
        onSearch={onSearch}
        dropdownRender={renderDropdownWithPagination}
        onBlur={setInputValue}
        onChange={onUserSelect}
        optionFilterProp={"value"}
        status={isError ? "error" : ""}
        allowClear={true}
      />
      {!isNullOrUndefined(selectedUser) ? (
        <div className="label">
          Select {selectedUser.fullName}'s conditions to find related users
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default SearchByUsers;
